import styled from 'styled-components/macro'

/* INTRO */
export const AnimationContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  img {
    position: absolute;
  }
  .celek {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .background {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .sun {
    top: 5%;
    right: 10%;
    @media (max-width: 1024px) {
      width: 96px;
    }
    @media (max-width: 520px) {
      width: 16%;
    }
  }
  .hand {
    position: absolute;
    //width: 100%;
    height: 62%;
    bottom: 0%;
    @media (max-aspect-ratio: 5/4) and (min-width: 1024px) {
      height: auto;
      width: 64%;
    }
    //left: 0%;
    right: 50%;
    transition: all 1.5s;
    transform: rotate(0deg);
    @media (max-width: 1024px) {
      transform: rotate(-12deg);
      right: 40%;
      height: auto;
      width: 48%;
    }
    @media (max-width: 520px) {
      right: 20%;
      height: auto;
      width: 82%;
      bottom: -3%;
    }
    picture {
      &:nth-child(3) {
        opacity: 0;
      }
      &:nth-child(2) {
        opacity: 0;
      }
      &:nth-child(1) {
        opacity: 1;
      }
    }
    img {
      //width: 100%;
      height: 100%;
      @media (max-aspect-ratio: 5/4) and (min-width: 1024px) {
        height: auto;
        width: 100%;
      }
      right: 0;
      bottom: 0;
      @media (max-width: 1024px) {
        height: auto;
        width: 100%;
      }
    }

    &.start {
      //left: -12%;
      bottom: -70%;
      right: 60%;
      transform: rotate(12deg);
    }
    &.ani {
      picture {
        &:nth-child(3) {
          animation: hand3 1.5s forwards;
          animation-iteration-count: 1;
        }
        &:nth-child(2) {
          animation: hand2 1.5s forwards;
          animation-iteration-count: 1;
        }
        &:nth-child(1) {
          animation: hand1 1.5s forwards;
          animation-iteration-count: 1;
        }
      }
    }
  }
  @keyframes hand1 {
    0% {
      opacity: 1;
    }
    60% {
      opacity: 1;
    }
    80% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes hand2 {
    40% {
      opacity: 0;
    }
    60% {
      opacity: 1;
    }
    80% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes hand3 {
    0% {
      opacity: 0;
    }
    60% {
      opacity: 0;
    }
    80% {
      opacity: 1;
    }
    100% {
      opacity: 1;
    }
  }
  .feather {
    position: absolute;
    transition: left 1.2s, top 1.2s, transform 1.2s, opacity 0s;
    transition-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  }
  .feather.start {
    opacity: 0;
  }
  .feather1 {
    width: 10%;
    top: 66.5%;
    left: 45.5%;
    transition-delay: 0.1s;
    &.start {
      top: 86%;
      left: 34%;
      transform: rotate(160deg);
    }
    @media (max-width: 1024px) {
      &.start {
        top: 76%;
      }
    }
    @media (max-width: 1024px) {
      width: 16%;
    }
  }
  .feather2 {
    width: 10%;
    top: 48%;
    left: 51%;
    transition-delay: 0.25s;
    &.start {
      top: 62%;
      left: 45%;
      transform: rotate(-270deg);
    }
    @media (max-width: 1024px) {
      width: 16%;
    }
    @media (max-width: 1024px) {
      width: 20%;
      left: 56%;
      &.start {
        top: 64%;
        left: 45%;
        transform: rotate(-180deg);
      }
    }
  }
  .feather3 {
    width: 10%;
    top: 76%;
    left: 29%;
    transition-delay: 0.1s;
    &.start {
      top: 92%;
      left: 15%;
      transform: rotate(-90deg);
    }
    @media (max-width: 1024px) {
      &.start {
        top: 86%;
      }
    }
    @media (max-width: 1024px) {
      width: 16%;
    }
  }
  .feather4 {
    width: 10%;
    top: 35%;
    left: 24.8%;
    transition-delay: 0.1s;
    &.start {
      top: 50%;
      left: 5%;
      transform: rotate(160deg);
    }
    @media (max-width: 1024px) {
      width: 8%;
      left: 30%;
      top: 42%;
      &.start {
        left: 16%;
        top: 56%;
      }
    }
    @media (max-width: 520px) {
      width: 12%;
      &.start {
        left: 6%;
        top: 76%;
      }
    }
  }
  .feather5 {
    width: 11%;
    top: 53%;
    left: 32.5%;
    transition-delay: 0.1s;
    &.start {
      top: 68%;
      left: 20%;
      transform: rotate(-75deg);
    }
    @media (max-width: 1024px) {
      width: 9%;
    }
    @media (max-width: 1024px) {
      width: 14%;
    }
  }
  .feather6 {
    width: 10%;
    top: 24%;
    left: 26%;
    transition-delay: 0.1s;
    &.start {
      top: 48%;
      left: 0%;
      transform: rotate(135deg);
    }
    @media (max-width: 1024px) {
      top: 38%;
      left: 38%;
      &.start {
        top: 48%;
        left: 28%;
      }
    }
    @media (max-width: 1024px) {
      width: 16%;
      &.start {
        top: 64%;
        left: 20%;
      }
    }
  }
  .feather7 {
    width: 10%;
    top: 22%;
    left: 30%;
    transition-delay: 0.15s;
    &.start {
      top: 42%;
      left: 10%;
      transform: rotate(180deg);
    }
    @media (max-width: 1024px) {
      top: 48%;
      left: 18%;
      &.start {
        top: 58%;
        left: 8%;
      }
    }
    @media (max-width: 1024px) {
      width: 16%;
    }
  }
  .bird {
    top: 46%;
    left: 60%;
    width: 48%;
    transform: translate(-50%, -50%);
    transition: all 0.6s;
    transition-timing-function: ease-out;

    @media (min-aspect-ratio: 16/9) and (min-width: 1024px) {
      width: auto;
      height: 70%;
    }
    @media (max-width: 1024px) {
      width: 56%;
    }
    @media (max-width: 520px) {
      width: 72%;
    }
  }
  .bird.start {
    top: 96%;
    left: -16%;
  }
`
